import { CONDITION_META, RECOMMENDATION_META, rupiah, fmtDateTime } from "../../lib/format";

export default function ReportView({ report }) {
  if (!report) return null;
  const groups = report.items.reduce((acc, it) => { (acc[it.group] ||= []).push(it); return acc; }, {});
  const rec = RECOMMENDATION_META[report.recommendation] || RECOMMENDATION_META.layak;
  const scoreColor = report.score >= 85 ? "text-emerald-600" : report.score >= 65 ? "text-amber-500" : "text-red-500";
  return (
    <div data-testid="report-view">
      <div className="grid sm:grid-cols-[auto_1fr] gap-5 items-center">
        <div className="text-center bg-slate-50 rounded-2xl px-8 py-5">
          <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">Skor Kondisi</p>
          <p className={`text-4xl font-extrabold ${scoreColor}`} data-testid="report-score">{report.score}</p>
          <p className="text-[11px] text-slate-400">dari 100</p>
        </div>
        <div>
          <span className={`inline-block text-white text-xs font-bold rounded-full px-3 py-1.5 ${rec.cls}`} data-testid="report-recommendation">{rec.label}</span>
          <p className="text-sm text-slate-600 mt-3 leading-relaxed">{report.summary}</p>
          <div className="flex flex-wrap gap-3 mt-3 text-[11px] font-semibold">
            {Object.entries(report.counts || {}).filter(([k, v]) => v > 0).map(([k, v]) => (
              <span key={k} className={`border rounded-full px-2.5 py-1 ${CONDITION_META[k]?.cls}`}>{v} {CONDITION_META[k]?.label}</span>
            ))}
            {report.estimated_repair_cost > 0 && <span className="border border-slate-200 rounded-full px-2.5 py-1 text-slate-600">Estimasi perbaikan {rupiah(report.estimated_repair_cost)}</span>}
          </div>
          <p className="text-[11px] text-slate-400 mt-2">Dikirim {fmtDateTime(report.submitted_at)}</p>
        </div>
      </div>
      <div className="mt-6 space-y-5">
        {Object.entries(groups).map(([g, items]) => (
          <div key={g}>
            <p className="text-xs font-extrabold text-slate-800 uppercase tracking-wide mb-2">{g}</p>
            <div className="divide-y divide-slate-50 border border-slate-100 rounded-xl overflow-hidden">
              {items.map((it) => (
                <div key={it.key} className="flex items-start justify-between gap-3 px-4 py-2.5 bg-white">
                  <div className="min-w-0">
                    <p className="text-[13px] font-semibold text-slate-700">{it.label}</p>
                    {it.note && <p className="text-xs text-slate-400 mt-0.5">{it.note}</p>}
                  </div>
                  <span className={`shrink-0 text-[11px] font-bold border rounded-full px-2.5 py-1 ${CONDITION_META[it.condition]?.cls}`}>{CONDITION_META[it.condition]?.label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {report.photos?.length > 0 && (
        <div className="mt-6">
          <p className="text-xs font-extrabold text-slate-800 uppercase tracking-wide mb-2">Foto Inspeksi ({report.photos.length})</p>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2" data-testid="report-photo-grid">
            {report.photos.map((p, i) => (
              <a key={i} href={p} target="_blank" rel="noreferrer" data-testid={`report-view-photo-${i}`}
                className="relative aspect-square rounded-lg overflow-hidden border border-slate-100 group">
                <img src={p} alt={`Foto inspeksi ${i + 1}`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
